import mapFileFromApi from 'rtkQuery/sharespro/mapper/shared/mapFileFromApi';
import { mapOrderBookItemFromApi } from 'rtkQuery/sharespro/mapper/shared/mapOrderBookFromApi';
import mapPeCompanyShortFromApi from './peCompany/mapPeCompanyShortFromApi';

export const mapPeOfferListItemFromApi = (
  resp: ApiPeOfferListItem
): PeOfferListItem => {
  return {
    company: mapPeCompanyShortFromApi(resp.company),
    id: resp.id,
    name: resp.name,
    subtitle: resp.subtitle,
    subtitleColor: resp.subtitle_color,
    logo: resp.logo ? mapFileFromApi(resp.logo) : null,
    orderBook: resp.order_book
      ? {
          buy:
            resp.order_book.buy.length > 0
              ? mapOrderBookItemFromApi(resp.order_book.buy[0])
              : null,
          sell:
            resp.order_book.sell.length > 0
              ? mapOrderBookItemFromApi(resp.order_book.sell[0])
              : null,
        }
      : null,
    progress: resp.progress
      ? {
          value: resp.progress.value,
          title: resp.progress.title,
        }
      : null,
    buttonText: resp.button_title,
    shortDescription: resp.short_description,
  };
};

const mapPeOffersFromApi = (resp: ApiPeOffers): PeOffers => {
  return {
    sharesproOffers: resp.company_orders.map(mapPeOfferListItemFromApi),
    investorsOffers: resp.investor_orders.map(mapPeOfferListItemFromApi),
    companies: resp.companies.map(mapPeOfferListItemFromApi),
  };
};

export default mapPeOffersFromApi;
